import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type ProductItem = {
  id: string;
  label: string;
  product: {
    displayInfoTitlesList: string[];
    externalId?: string;
    internalId?: string;
    type: string;
  };
};

const ItemId = ({ item }: { item: ProductItem }) => {
  const { t } = useTranslation();
  return (
    <Typography variant="caption" color="text.disabled">
      {item.product.externalId
        ? t('drawer.createOfferDrawers.product.externalId')
        : t('drawer.addProductsDrawer.incentivioId')}
      : {item.id}
    </Typography>
  );
};

export default ItemId;
